import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';

import { Button, Divider, Paper, Stack, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import SignInWithApple from '../../services/auth/apple-auth.service';
import SignInWithFacebook from '../../services/auth/facebook-auth.service';
import NativeLogin from '../login/NativeLogin';

interface IProps {
    isOpen: boolean;
    handleClose: () => void;
    googleLogin?: () => void;
    otpHandler: () => void;
}

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 450,
    width: { xs: 300, sm: 325, lg: 450 },
    bgcolor: 'background.default',
    //   border: "2px solid #000",
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
    border: '2px solid #16CECC'
};
const AppModal: React.FC<IProps> = ({ isOpen, handleClose, otpHandler }) => {
    const navigation = useNavigate();
    const [loginTxt, setloginTxt] = useState('');
    const [passTxt, setpassTxt] = useState('');

    const [error_pass, setError_pass] = useState('');
    const [error_email, setError_email] = useState('');
    const { t } = useTranslation();

    const NativeLoginSubmit = async () => {
        setError_email('');
        setError_pass('');
        if (loginTxt.trim().length === 0) {
            setError_email(t('forget_pass_page.email_addres_please'));
            return false;
        }

        if (passTxt.trim().length === 0) {
            setError_pass(t('signup_page.enter_your_password'));
            return false;
        }

        var pattern = new RegExp(
            /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
        );

        let isEmail = pattern.test(loginTxt.trim());

        if (!isEmail) {
            setError_email('Email is not valid');
            return false;
        } else {
            await NativeLogin(loginTxt.trim(), passTxt.trim(), setError_email, handleClose);
        }
    };

    const goToForgotPassword = () => {
        handleClose();
        navigation('/ForgotPassword');
    };
    const goToSignup = () => {
        handleClose();
        navigation('/signup');
    };

    return (
        <Modal open={isOpen} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Paper sx={style}>
                <CloseIcon
                    sx={{
                        width: '7%',
                        height: '7%',
                        position: 'absolute',
                        right: 17,
                        top: 12
                    }}
                    onClick={handleClose}
                />
                <Typography id="modal-modal-title" variant="h5" sx={{ fontSize: 27, fontWeight: '700', color: 'text.primary' }}>
                    {t('per_sign_up_page.log_in')}
                </Typography>
                <Box>
                    <TextField
                        fullWidth
                        required
                        label={t('login_page.email')}
                        id="email"
                        size="small"
                        margin="normal"
                        autoComplete="nope"
                        autoFocus={true}
                        inputProps={{ maxLength: 30 }}
                        onChange={(event) => {
                            setloginTxt(event.target.value);
                        }}
                        value={loginTxt}
                        error={error_email !== ''}
                        helperText={error_email}
                    />
                    <TextField
                        fullWidth
                        required
                        label={t('login_page.password')}
                        id="password"
                        type="password"
                        autoComplete="current-password"
                        size="small"
                        margin="normal"
                        inputProps={{ maxLength: 30 }}
                        onChange={(val) => setpassTxt(val.target.value)}
                        error={error_pass !== ''}
                        helperText={error_pass}
                    />
                    <Button fullWidth size="large" sx={{ bgcolor: 'primary.main', '&:hover': { bgcolor: 'primary.main' }, color: 'white', marginTop: 1.8 }} onClick={NativeLoginSubmit}>
                        {t('login_page.login')}
                    </Button>
                    <Stack direction="row" sx={{ marginTop: 1 }}>
                        <Button onClick={goToForgotPassword} fullWidth sx={{ fontSize: 9, justifyContent: 'left', color: 'text.primary' }}>
                            {t('login_page.forgot_password')}
                        </Button>
                        {/* <Button href="" fullWidth sx={{ fontSize: 9, justifyContent: 'right', color: 'text.primary' }}>
                            {t('login_page.login_in_with_phone_number')}
                        </Button> */}
                    </Stack>
                    <Divider>
                        <Typography>{t('login_page.or')}</Typography>
                    </Divider>
                    <Stack direction="row" sx={{ marginTop: 1 }} spacing={3}>
                        <Button fullWidth variant="outlined" size="large" onClick={otpHandler} sx={{ color: 'text.primary', fontSize: 9 }}>
                            {t('login_page.by_phone')}
                        </Button>
                        <SignInWithFacebook onSuccess={handleClose} />
                        {/* <SignInWithGoogle onSuccess={handleClose} /> */}
                        <SignInWithApple />
                    </Stack>
                    <Stack direction="row" justifyContent="center" alignItems="center" spacing={0.2} sx={{ marginTop: 3 }}>
                        <Typography fontSize={12}>{t('login_page.new_to')} UZOFFER?</Typography>

                        <Typography fontSize={12} fontWeight="bold" component="button" onClick={goToSignup}>
                            {t('signup_page.sign_up')}
                        </Typography>
                    </Stack>
                </Box>
            </Paper>
        </Modal>
    );
};

export default React.memo(AppModal, (prevProps, nextProps) => {
    return prevProps.isOpen === nextProps.isOpen;
});
